import { useSeo } from "@/hooks/useSeo";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const CookiesPage = () => {
  useSeo('Cookie Policy | Luxe Lords', 'How Luxe Lords uses cookies and how to manage your choices.', '/cookies');
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="pt-32 pb-20 px-6 lg:px-12">
        <article className="container mx-auto max-w-3xl">
          
          <h1 className="font-serif text-3xl md:text-4xl font-normal tracking-tight text-foreground mb-3">Cookie Policy</h1>
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-14">Last updated: 19 May 2026</p>

          <div className="space-y-8 text-body text-muted-foreground leading-relaxed">
            <section>
              <h2 className="font-serif text-xl md:text-2xl font-normal tracking-tight text-foreground mb-3">What are cookies?</h2>
              <p>
                Cookies and similar technologies (such as <em>localStorage</em>) are small pieces of
                data stored on your device by your browser. We use them only where strictly
                necessary to operate this website, in line with the Privacy and Electronic
                Communications Regulations (PECR) and the UK GDPR.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl md:text-2xl font-normal tracking-tight text-foreground mb-3">Our position</h2>
              <p>
                <strong>We do not use advertising, marketing, or analytics cookies.</strong> No
                third-party tracker is loaded on this site. Because the storage we set is{" "}
                <strong>strictly necessary</strong> to deliver the shop, your prior consent is not
                required under PECR — but we still tell you about it for transparency.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl md:text-2xl font-normal tracking-tight text-foreground mb-3">What we store</h2>
              <div className="overflow-x-auto">
                <table className="w-full text-sm border border-border">
                  <thead className="bg-secondary/60">
                    <tr>
                      <th className="text-left p-3 border-b border-border text-foreground">Name</th>
                      <th className="text-left p-3 border-b border-border text-foreground">Type</th>
                      <th className="text-left p-3 border-b border-border text-foreground">Purpose</th>
                      <th className="text-left p-3 border-b border-border text-foreground">Duration</th>
                    </tr>
                  </thead>
                  <tbody className="text-muted-foreground">
                    <tr>
                      <td className="p-3 border-b border-border">luxe-lords-cart</td>
                      <td className="p-3 border-b border-border">localStorage (first-party)</td>
                      <td className="p-3 border-b border-border">Keeps your basket between visits.</td>
                      <td className="p-3 border-b border-border">Until cleared</td>
                    </tr>
                    <tr>
                      <td className="p-3 border-b border-border">ll_cookie_notice_ack_v1</td>
                      <td className="p-3 border-b border-border">localStorage (first-party)</td>
                      <td className="p-3 border-b border-border">Remembers that you closed the cookie notice.</td>
                      <td className="p-3 border-b border-border">Until cleared</td>
                    </tr>
                    <tr>
                      <td className="p-3 border-b border-border">sb-* (Supabase)</td>
                      <td className="p-3 border-b border-border">localStorage (first-party)</td>
                      <td className="p-3 border-b border-border">Maintains a secure session for contact form / chat backend.</td>
                      <td className="p-3 border-b border-border">Session</td>
                    </tr>
                    <tr>
                      <td className="p-3">Shopify checkout cookies</td>
                      <td className="p-3">third-party (on checkout pages only)</td>
                      <td className="p-3">Required by Shopify to process payments and prevent fraud.</td>
                      <td className="p-3">See Shopify's cookie policy</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section>
              <h2 className="font-serif text-xl md:text-2xl font-normal tracking-tight text-foreground mb-3">Managing cookies</h2>
              <p>
                You can clear or block cookies and local storage at any time through your browser
                settings. Doing so may break basket and checkout functionality. If we ever
                introduce analytics or marketing cookies, we will ask for your explicit consent
                first through an updated cookie banner.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl md:text-2xl font-normal tracking-tight text-foreground mb-3">Contact</h2>
              <p>
                Questions about cookies? Email{" "}
                <a className="underline hover:text-foreground" href="mailto:info@luxelords.com">
                  info@luxelords.com
                </a>.
              </p>
            </section>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default CookiesPage;
